var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinSolidNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8922 7.74353L12.3037 1.11037C11.9377 0.741857 11.3886 0.741857 11.0226 1.11037C10.6566 1.47888 10.6566 2.03164 11.0226 2.40015L11.2056 2.5844L5.89823 6.36162L2.97002 6.73013C2.05496 6.91439 1.2314 7.55928 0.956877 8.38842C0.682358 9.21757 0.865371 10.231 1.50592 10.7837L4.70864 14.0082L2.42098 16.3114C2.05496 16.6799 2.05496 17.2326 2.42098 17.6012C2.60399 17.7854 2.87851 17.8775 3.06153 17.8775C3.24454 17.8775 3.51906 17.7854 3.70207 17.6012L5.98974 15.298L9.19246 18.5224C9.65 18.9831 10.199 19.1673 10.8396 19.1673C11.1141 19.1673 11.3886 19.1673 11.5716 19.0752C12.4867 18.7988 13.1272 17.9697 13.2188 17.0484L13.6763 14.1003L17.3365 8.84906L17.6111 9.12544C17.7941 9.3097 18.0686 9.40182 18.2516 9.40182C18.4346 9.40182 18.7091 9.3097 18.8922 9.12544C19.2582 8.75693 19.2582 8.11204 18.8922 7.74353Z",
    fill: "#E4B900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinSolidNew);
export default __webpack_public_path__ + "static/media/pin_solid_new.b62c0d0886026ee5a9030c9a83f498c9.svg";
export { ForwardRef as ReactComponent };